import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/register',
			name: 'register',
			component: resolve => require(['@/components/register/register'], resolve)
		},
		{
			path: '/login',
			name: 'login',
			component: resolve => require(['@/components/login/login'], resolve)
		},
		{
			path: '/',
			name: 'index',
			component: resolve => require(['@/components/index'], resolve),
			redirect: '/fanyi',
			children: [{
					path: '/indexModular',
					name: 'indexModular',
					component: resolve => require(['@/components/Modular/indexModular'], resolve)
				},
				{
					path: '/fanyi',
					name: 'fanyi',
					component: resolve => require(['@/components/fanyi/fanyi'], resolve)
				},
				{
					path: '/myPapersModular',
					name: 'myPapersModular',
					component: resolve => require(['@/components/Modular/myPapersModular'], resolve)
				},
				{
					path: '/personal',
					name: 'personal',
					component: resolve => require(['@/components/personal/personal'], resolve)
				},
				{
					path: '/pay',
					name: 'pay',
					component: resolve => require(['@/components/pay/pay'], resolve)
				},
				{
					path: '/readTranslate',
					name: 'readTranslate',
					component: resolve => require(['@/components/Modular/readTranslate'], resolve)
				},
			]
		},
		{
			path: '/middle',
			name: 'middle',
			component: resolve => require(['@/components/middle'], resolve)
		},
		{
			path: '/payMiddle',
			name: 'payMiddle',
			component: resolve => require(['@/components/payMiddle'], resolve)
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js